var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    {
      staticClass: "row view-panel",
      class: { toggle: _vm.toggle },
      attrs: { show: _vm.loadingFile }
    },
    [
      _c("div", { staticClass: "col-md-12 button-panel" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-end" },
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.activeElement &&
                      _vm.activeElement.type === "file" &&
                      _vm.isGore,
                    expression:
                      "activeElement && activeElement.type === 'file' && isGore"
                  },
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Seleccionar documento",
                    expression: "'Seleccionar documento'"
                  }
                ],
                staticClass: "badge-glow mr-2",
                attrs: {
                  "data-cy": "select-document",
                  variant: "warning",
                  size: "sm",
                  disabled:
                    _vm.userPermissions.read === 0 ||
                    _vm.files.length >= _vm.maxFiles
                },
                on: {
                  click: function($event) {
                    return _vm.selectToDoc(false)
                  }
                }
              },
              [
                _c("feather-icon", {
                  attrs: { icon: "CheckIcon", size: "16" }
                }),
                _vm._v(" Seleccionar ")
              ],
              1
            ),
            _vm.showPrincipalButton
              ? _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.activeElement &&
                          _vm.activeElement.type === "file" &&
                          _vm.isGore,
                        expression:
                          "activeElement && activeElement.type === 'file' && isGore"
                      },
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Seleccionar documento como archivo principal",
                        expression:
                          "'Seleccionar documento como archivo principal'"
                      }
                    ],
                    staticClass: "badge-glow",
                    attrs: {
                      "data-cy": "select-main-document",
                      variant: "warning",
                      size: "sm",
                      disabled: _vm.userPermissions.read === 0
                    },
                    on: {
                      click: function($event) {
                        return _vm.selectToDoc(true)
                      }
                    }
                  },
                  [
                    _c("feather-icon", {
                      attrs: { icon: "CheckIcon", size: "16" }
                    }),
                    _vm._v(" Seleccionar como principal ")
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          {
            staticClass:
              "mt-4 wrap-table shadow bg-white rounded overflow-y-scroll view-table"
          },
          [
            _c("table", { staticClass: "w-100 rounded" }, [
              _c(
                "thead",
                {
                  staticClass: "fb-bg-primary",
                  staticStyle: { color: "white" }
                },
                [
                  _c("tr", [
                    _c("th", [_vm._v(" Estado ")]),
                    _c("th", [_vm._v(" Nombre ")]),
                    _c("th", { staticClass: "text-center" }, [
                      _vm._v(" Tamaño ")
                    ]),
                    _c("th", [_vm._v(" Fecha Creación ")]),
                    _c("th", [_vm._v(" Propietario ")])
                  ])
                ]
              ),
              _c(
                "tbody",
                { attrs: { id: "folder-elements" } },
                [
                  _vm._l(_vm.folderElements, function(element) {
                    return _c("MinimalNavigationElement", {
                      key: element.id,
                      attrs: { element: element, "data-cy": "folder" }
                    })
                  }),
                  _vm._l(_vm.fileElements, function(element) {
                    return _c("MinimalNavigationElement", {
                      key: element.id,
                      attrs: { element: element, "data-cy": "file" }
                    })
                  }),
                  _vm.isEmptyFolder
                    ? _c("tr", [
                        _c("td", { attrs: { colspan: "5" } }, [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-center m-5" },
                            [
                              _c("span", [
                                _vm._v("Ups! esta carpeta esta vacía.")
                              ])
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                2
              ),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loadingElements,
                      expression: "loadingElements"
                    }
                  ]
                },
                [
                  _c(
                    "td",
                    { staticClass: "pl-5 pt-2" },
                    [
                      _c("b-skeleton", {
                        staticClass: "bg-grey-light w-50",
                        attrs: { animation: "fade" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "pl-5 pt-2" },
                    [
                      _c("b-skeleton", {
                        staticClass: "bg-grey-light w-100",
                        attrs: { animation: "fade" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "pl-5 pt-2" },
                    [
                      _c("b-skeleton", {
                        staticClass: "bg-grey-light w-100",
                        attrs: { animation: "fade" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "pl-5 pt-2" },
                    [
                      _c("b-skeleton", {
                        staticClass: "bg-grey-light w-100",
                        attrs: { animation: "fade" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "pl-5 pt-2" },
                    [
                      _c("b-skeleton", {
                        staticClass: "bg-grey-light w-100",
                        attrs: { animation: "fade" }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loadingElements,
                      expression: "loadingElements"
                    }
                  ]
                },
                [
                  _c(
                    "td",
                    { staticClass: "pl-5 pt-2" },
                    [
                      _c("b-skeleton", {
                        staticClass: "bg-grey-light w-50",
                        attrs: { animation: "fade" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "pl-5 pt-2" },
                    [
                      _c("b-skeleton", {
                        staticClass: "bg-grey-light w-100",
                        attrs: { animation: "fade" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "pl-5 pt-2" },
                    [
                      _c("b-skeleton", {
                        staticClass: "bg-grey-light w-100",
                        attrs: { animation: "fade" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "pl-5 pt-2" },
                    [
                      _c("b-skeleton", {
                        staticClass: "bg-grey-light w-100",
                        attrs: { animation: "fade" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "pl-5 pt-2" },
                    [
                      _c("b-skeleton", {
                        staticClass: "bg-grey-light w-100",
                        attrs: { animation: "fade" }
                      })
                    ],
                    1
                  )
                ]
              )
            ])
          ]
        )
      ]),
      _vm.modalName
        ? _c("FileFormView", { attrs: { isEdit: _vm.isEdit } })
        : _vm._e(),
      _vm.modalName
        ? _c("FolderFormView", { attrs: { isEdit: _vm.isEdit } })
        : _vm._e(),
      _vm.modalName ? _c("WizardDocumentosPersonalizados") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }